import React, { useEffect, useState } from 'react';

import { batch } from 'react-redux';
import { mountIntoContainer, unmountFromContainer } from '~/src/containers/SingletonHook/SingletonHooksContainer';

// преобразует любой хук в singleton
export const singletonHook = <HookReturn, HookArgs extends any[] = any[]>(
    // начальное возвращаемое значением
    initValue: HookReturn,
    useHookBody: (...HookArgs) => HookReturn
) => {
    let mounted = false;
    // вычислено ли начальное состояние хука
    let initStateCalculated = false;
    // последнее возвращаемое значение хука
    let lastKnownState: HookReturn | undefined;
    // массив всех потребителей хука
    const consumers: React.Dispatch<React.SetStateAction<HookReturn>>[] = [];

    // applyStateChange будет выполняться при каждом изменении возвращаемого значения
    const applyStateChange = (newState: HookReturn) => {
        lastKnownState = newState;
        batch(() => consumers.forEach((setState) => setState(newState)));
    };

    // сохраняет начальное состояние
    const stateInitializer = () => {
        if (!initStateCalculated) {
            lastKnownState = initValue;
            initStateCalculated = true;
        }
        return lastKnownState;
    };

    // сделать этот хук singleton
    return (args: HookArgs) => {
        const [state, setState] = useState(stateInitializer);

        useEffect(() => {
            if (!mounted) {
                mounted = true;
                mountIntoContainer<HookReturn, HookArgs>({
                    initValue,
                    useHookBody,
                    applyStateChange,
                    args,
                });
            }

            consumers.push(setState);
            if (lastKnownState && lastKnownState !== state) {
                setState(lastKnownState);
            }

            return () => {
                consumers.splice(consumers.indexOf(setState), 1);
                if (consumers.length === 0) {
                    mounted = false;
                    initStateCalculated = false;
                    lastKnownState = undefined;
                    unmountFromContainer({
                        initValue,
                        useHookBody,
                        applyStateChange,
                        args,
                    });
                }
            };
        }, []);

        return state;
    };
};
